import { render, staticRenderFns } from "./ProjectTitleCard.vue?vue&type=template&id=3391771f&scoped=true&"
import script from "./ProjectTitleCard.vue?vue&type=script&lang=js&"
export * from "./ProjectTitleCard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTitleCard.vue?vue&type=style&index=0&id=3391771f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3391771f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
